import { createFileRoute } from "@tanstack/react-router";
import { useInfiniteQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { queryKeys } from "@/lib/queryKeys";
import { Skeleton } from "@/components/Skeleton";
import { ActivityFeed, type ActivityItem } from "@/components/ActivityFeed";

/**
 * S8 Activity — docs/themes/default/Activity.html
 * Vertical timeline of recent edits rendered via the shared ActivityFeed
 * component. The project breadcrumb, header and tab strip live in the
 * parent layout route (`route.tsx`); this view renders content only.
 */
function ActivityPage() {
  const { projectId } = Route.useParams();
  const q = useInfiniteQuery({
    queryKey: queryKeys.activityFor(projectId),
    queryFn: ({ pageParam }) =>
      api.listActivity(projectId, pageParam as string | undefined),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (last) => last.nextCursor ?? undefined,
  });
  const items: ActivityItem[] = q.data?.pages.flatMap((p) => p.items) ?? [];

  return (
    <div className="proj-shell-content">
      {q.isLoading ? (
        <Skeleton count={5} height={56} style={{ marginBottom: 8 }} />
      ) : (
        <ActivityFeed
          items={items}
          hasMore={!!q.hasNextPage}
          onLoadMore={() => q.fetchNextPage()}
        />
      )}
    </div>
  );
}

export const Route = createFileRoute("/projects/$projectId/activity")({
  component: ActivityPage,
});
